import { queryClient } from '@/config/query-client.config';
import {
  UnderwearPromotionRequest,
  UnderwearPromotionResponse,
  UpdateUnderwearPromotionRequest,
} from '@repo/types/src/underwear-promotion';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  createUnderwearPromotion,
  deleteUnderwearPromotion,
  getAllUnderwearPromotions,
  updateUnderwearPromotion,
} from './underwear-promotion.queries';
import { underwearPromotionQueryKeys } from './underwear-promotion.query-keys';

export const useGetUnderwearPromotions = () => {
  const {
    data: promotions,
    isError,
    isLoading,
  } = useQuery({
    queryKey: underwearPromotionQueryKeys.all,
    queryFn: getAllUnderwearPromotions,
  });
  return { promotions, isError, isLoading };
};

export const useCreateUnderwearPromotion = () =>
  useMutation({
    mutationFn: (payload: UnderwearPromotionRequest) =>
      createUnderwearPromotion(payload),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: underwearPromotionQueryKeys.all,
      }),
  });

export const useUpdateUnderwearPromotion = () =>
  useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: number;
      payload: UpdateUnderwearPromotionRequest;
    }) => updateUnderwearPromotion(id, payload),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: underwearPromotionQueryKeys.all,
      }),
  });

export const useDeleteUnderwearPromotion = () =>
  useMutation({
    mutationFn: (id: number) => deleteUnderwearPromotion(id),
    onSuccess: (data: UnderwearPromotionResponse) =>
      queryClient.setQueryData<UnderwearPromotionResponse[]>(
        underwearPromotionQueryKeys.all,
        (old) => old?.filter((p) => p.id !== data.id),
      ),
  });
